module.exports = __webpack_public_path__ + "img/HZ-A1010.c29d95ca.jpg";